<!-- ==============================
    File Name: Login.vue
    Description: Login Page
    -------------------------------
=============================== -->

<template>
  <div>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center p-20" slot="header">
      <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/">
        <img src="/img/logo/logo.png" class="app-login-logo" />
      </router-link>
  </div>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center pt-15" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 v-if="showForgotpass" class="mb-6">Forgot Password</h4>
                  <h4 v-if="!showForgotpass" class="mb-4">Login</h4>
                  <p v-if="!showForgotpass">Welcome back, please login to your account.</p>
                </div>
                <div>
                  <vs-input
                      v-validate="'required|email|min:3'"
                      data-vv-validate-on="blur"
                      name="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="email"
                      v-on:keyup.enter="loginJWT"
                      class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('email') }}.</span>

                  <vs-input
                      v-if="!showForgotpass"
                      data-vv-validate-on="blur"
                      v-validate="'required|min:6|max:100'"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="password"
                      v-on:keyup.enter="loginJWT"
                      class="w-full mt-6" />
                  <span v-if="!showForgotpass" class="text-danger text-sm">{{ errors.first('password') }}.</span>

                  <div class="flex flex-wrap justify-between my-5">
                      <vs-button v-if="!showForgotpass" :disabled="!validateForm" @click="loginJWT">Login</vs-button>
                      <vs-button v-if="showForgotpass" :disabled="!validateForgotPasswordForm" @click="sendResetPasswordLink">Send Reset Link</vs-button>
                      <vs-button v-if="showForgotpass" @click="showForgotpass = false">Cancel</vs-button>
                  </div>
                  
                  <a class="pointer" v-if="!showForgotpass" @click.prevent="showForgotpass = true">Forgot Password?</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
  </div>
</template>

<script>
import UtilService from "@/services/UtilService";
import UserService from "@/services/UserService";
import firebase from "firebase";

export default {
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      showForgotpass: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && UtilService.validateEmail(this.email) !== '' && this.password !== ''
    },
    validateForgotPasswordForm () {
      return !this.errors.any() && UtilService.validateEmail(this.email) !== ''
    }
  },
  created () {
    this.redirectToRoleWise ();
  },
  methods: {
    loginJWT () {
      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      UserService.loginWithFirebase(this.email, this.password, (err, data) => {
        if(!err){
          this.$vs.loading.close();
          this.$store.dispatch('auth/loginJWT', payload)
            .then((UserDetails) => {
              if(UserDetails && UserDetails.Status === 'InActive'){ 
                UtilService.notifyErrorAlert(this.$vs, 'You are not able to Login.')
              } else {
                this.$vs.loading.close();
                UtilService.notifySuccessAlert(this.$vs, 'You are login successfully.');
                this.redirectToRoleWise();
              }
            })
            .catch(error => {
              this.$vs.loading.close()
              UtilService.notifyErrorAlert(this.$vs, error.message);
            })
        } else {
          console.log(err)
          this.$vs.loading.close();
          UtilService.notifyErrorAlert(this.$vs, 'Invalid email and password.');
        }
      });
    }, 

    sendResetPasswordLink() {
      if(this.email){
        firebase
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            UtilService.notifySuccessAlert(this.$vs, 'Reset password link sent successfully.');
            this.showForgotpass = false;
          }).catch((error) => {
            if(error && error.code == 'auth/user-not-found'){
              UtilService.notifyErrorAlert(this.$vs, 'You are not registered user.');
            } else {
              UtilService.notifyErrorAlert(this.$vs, error.message);
            }
          })
      } else {
        UtilService.notifyErrorAlert(this.$vs, 'Please enter email.');
      }
    },

    redirectToRoleWise () {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if(userInfo && (userInfo.Role === 'Admin' || userInfo.Role === 'Manager')){
        window.location.href = '/admin-dashboard'
      } else if(userInfo && userInfo.Role === 'Partner Admin'){
        window.location.href = '/partner-dashboard'
      } else if(userInfo && userInfo.Role === 'Partner Staff'){
        window.location.href = '/apps/client/list'
      }
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
.pointer{
  cursor: pointer;
}
</style>
